import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'
import { prepareSearchParams } from '@/libs/helper'

const resource = `${Config.basePath}/v1/api/admin/transaction/request`

export default {
  index(payload) {
    let params = prepareSearchParams(payload)
    params = {
      ...payload,
      ...params,
      username: payload.search,
    }
    if (payload.startDate) {
      params.filters.push({
        searchby: 'created_at',
        searchoperator: '>',
        search: `${payload.startDate} 00:00:00`,
      })
    }
    if (payload.endDate) {
      params.filters.push({
        searchby: 'created_at',
        searchoperator: '<',
        search: `${payload.endDate} 23:59:59`,
      })
    }
    if (payload.status) {
      params.filters.push({
        searchby: 'status',
        searchoperator: '=',
        search: payload.status,
      })
    }
    return Client.post(`${resource}/deposit`, params, {
      headers: {
        action: 'list-deposit-request',
      },
    })
  },
  total(payload) {
    let params = prepareSearchParams(payload)
    params = {
      ...payload,
      ...params,
      username: payload.search,
    }
    if (payload.startDate) {
      params.filters.push({
        searchby: 'created_at',
        searchoperator: '>',
        search: `${payload.startDate} 00:00:00`,
      })
    }
    if (payload.endDate) {
      params.filters.push({
        searchby: 'created_at',
        searchoperator: '<',
        search: `${payload.endDate} 23:59:59`,
      })
    }
    if (payload.status) {
      params.filters.push({
        searchby: 'status',
        searchoperator: '=',
        search: payload.status,
      })
    }
    return Client.post(`${resource}/deposit`, params, {
      headers: {
        action: 'total-deposit-request',
      },
    })
  },
  update(payload) {
    return Client.post(`${resource}`, payload, {
      headers: {
        action: 'update-request-status',
      },
    })
  },
  count() {
    const params = prepareSearchParams({})
    params.filters.push({
      searchby: 'status',
      searchoperator: '=',
      search: '0',
    })
    return Client.post(`${resource}/deposit`, params, {
      headers: {
        action: 'count-deposit-withdrawal-request',
      },
    })
  },
}
